import Glide from '@glidejs/glide'

/**
 * Get all the sliders on a given page.
 */
const getSliders = () => document.querySelectorAll('[data-hdm-slider]');

/**
 * Setup a live region for screen readers within an element.
 *
 * @param {Element} element
 */
const setupLiveRegion = element => {
  const liveregion = document.createElement('div');
  liveregion.setAttribute('aria-live', 'polite');
  liveregion.setAttribute('aria-atomic', 'true');
  liveregion.setAttribute('class', 'liveregion screen-reader-text');
  element.appendChild(liveregion);
}

/**
 * Handle slide move events with Glide.
 *
 * @param {Element} element
 * @param {Element[]} slides
 * @param {Object} glide
 */
const onMoveHandler = (element, slides, glide) => {
  element.querySelector('.liveregion').textContent =
      `Slide ${glide.index + 1} of ${slides.length}`;

  slides.forEach((slide, index) => {
    slide.setAttribute('aria-hidden', index !== glide.index);
  });
}

const onMoveBeforeHandler = (element, slides, glide) => {
  const counterContainer = element.querySelector('.slide-counter')

  if(counterContainer) {
    counterContainer.querySelector('.slide-counter-current').textContent = (glide.index + 1)
  }
}

/**
 * Attach left and right arrow keyboard handlers to the container.
 *
 * @param {Element} element
 * @param {Object} glide
 */
const attachKeyboardEvents = (element, glide) => {
  element.addEventListener('keyup', (e) => {
    switch(e.keyCode) {
      case 39:
        glide.go('>');
        break;

      case 37:
        glide.go('<');
    }
  });
}

/**
 * Initialize each slider.
 *
 * @param {Element} sliderEl
 */
const initializeSlider = sliderEl => {
  const element = sliderEl.querySelector('.glide');
  const slides  = sliderEl.querySelectorAll('.glide__slide');

  if (!element) {
    return;
  }

  // Hacky way of doing it but seems to be the only option available right now.
  const isOverflowStyle = !sliderEl.classList.value.includes("is-style-single")

  setupLiveRegion(element);

  const options = {
    peek: 0,
    perView: 1,
    gap: 0,
    // Glide keyboard events look at the whole document, so using the right/left arrow
    // anywhere on the page will change all sliders on the page, no matter where you were.
    // We want to turn that behavior off, and instead use our own keyboard events.
    keyboard: false,
  }

  const glide = new Glide(element, options);

  glide.on('move', () => onMoveBeforeHandler(element, slides, glide));
  glide.on('move.after', () => onMoveHandler(element, slides, glide));

  attachKeyboardEvents(element, glide);

  const counterContainer = element.querySelector('.slider__counter')

  const counterCurrent = document.createElement('span')
  counterCurrent.classList.add('slide-counter-current')
  counterCurrent.textContent = (glide.index + 1)

  const counterDivider = document.createElement('span')
  counterDivider.classList.add('slide-counter-divider')
  counterDivider.textContent = '/'

  const counterTotal = document.createElement('span')
  counterTotal.classList.add('slide-counter-total')
  counterTotal.textContent = slides.length

  counterContainer.append(counterCurrent, counterDivider, counterTotal)

  glide.mount();
}

/**
 * Kick off our slider scripts.
 */
const initialize = () => {
  const sliders = getSliders();

  // No sliders to work with, bounce.
  if (sliders.length < 1) {
    return;
  }

  sliders.forEach(element => initializeSlider(element));
}
document.addEventListener("DOMContentLoaded", initialize);
